import { BACKEND_URL_PREFIX, itemsOnPage } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import {
  NETWORK_REQUEST_SENT,
  FETCH_PERSONNEL_COMPLETED,
  FETCH_GRADES_START,
  FETCH_GRADES_FAILED,
  FETCH_GRADES_COMPLETED,
  SET_GRADES_START,
  SET_GRADES_COMPLETED,
  SET_GRADES_FAILED,
  SET_PERMANENT_STAFF,
  SET_VARIABLE_STAFF,
  SET_PERMANENT_STAFF_PAGES_COUNT,
  SET_DIVISIONS,
  RASHOD_REMOVE,
  RASHOD_FETCH_STARTED,
  SET_GROUPS_BY_COURSE,
  SET_GROUPS_BY_SCHEDULE,
  SET_RASHOD_COURSES,
  SET_RASHOD_ABSENCE,
  FETCH_PERSONNEL_FAILED
} from "./types";

// Расход на дату. Пустое значение отбора («Все») в запрос не уходит.
// Порядок групп и обучающихся задаёт сервер — на клиенте не пересортировывается.
export const fetchPersonnel = (date, idfaculty, eyid, gid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: RASHOD_FETCH_STARTED });
    const params = { date: date.format("YYYY-MM-DD") };
    if (idfaculty && idfaculty !== '0') params.idfaculty = idfaculty;
    if (eyid && eyid !== '0') params.eyid = eyid;
    if (gid && gid !== '0') params.gid = gid;
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal_rashod?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      // «Ничего не найдено» — не ошибка: об этом говорит пустое состояние режима
      await dispatch({
        type: FETCH_PERSONNEL_COMPLETED,
        payload: { groups: data.groups || [], canEdit: data.can_edit },
      });
    } else {
      await dispatch({ type: FETCH_PERSONNEL_FAILED });
    }
  }
};

// Отметка отсутствия, сохранённая на сервере, — в уже показанном расходе.
// Перезапрашивать весь расход ради одной ячейки не нужно.
export const setRashodAbsence = (gid, mid, absence) => ({
  type: SET_RASHOD_ABSENCE,
  payload: { gid, mid, absence },
});

export const fetchAbsentGrades = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_GRADES_START });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/grade_values/absent`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_GRADES_COMPLETED, payload: data });
    } else {
      dispatch({ type: FETCH_GRADES_FAILED });
    }
  }
};

export const setGrade = (mid, date, grade) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_GRADES_START });
    const response = await fetch(`${BACKEND_URL_PREFIX}/journal_rashod/grade`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
      },
      body: JSON.stringify({
        mid,
        date: date.format("YYYY-MM-DD"),
        grade: grade || null,
      }),
    });

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: SET_GRADES_COMPLETED, payload: data });
      return { ok: true };
    }

    // текст отказа отдаёт сервер: режим возвращает прежнее значение и показывает его
    const error = await response.json().catch(() => null);
    dispatch({ type: SET_GRADES_FAILED });
    return {
      ok: false,
      status: response.status,
      error: error?.error || 'Не удалось сохранить отметку',
    };
  }

  return { ok: false, error: 'Сеанс работы завершён' };
};

export const fetchRashodCourses = (date, idfaculty) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = { date: date.format("YYYY-MM-DD") };
    if (idfaculty && idfaculty !== '0') params.idfaculty = idfaculty;
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal_rashod/courses?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: SET_RASHOD_COURSES, payload: data || [] });
    } else {
      await dispatch({ type: SET_RASHOD_COURSES, payload: [] });
    }
  }
};

export const fetchGroupsByScheduleDate = (date, idfaculty, eyid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = { date: date.format("YYYY-MM-DD") };
    if (idfaculty && idfaculty !== '0') params.idfaculty = idfaculty;
    if (eyid && eyid !== '0') params.eyid = eyid;
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal_rashod/groups?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      const groups = (data || []).map(g => ({
        gid: g.gid,
        value: String(g.gid),
        name: g.name || g.groupname,
        ...g
      }));
      await dispatch({ type: SET_GROUPS_BY_SCHEDULE, payload: groups });
    } else {
      await dispatch({ type: SET_GROUPS_BY_SCHEDULE, payload: [] });
    }
  }
};

export const fetchPermanentStaff = (pageNumber, findString, findDivision, status) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: RASHOD_FETCH_STARTED })
    dispatch(fetchPermanentStaffCount(findString, findDivision, status))
    const params = {
      paginateFrom: itemsOnPage * pageNumber,
      maxResults: itemsOnPage,
      status: status
    }
    findDivision!=='all' && (params.division = findDivision)
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/teachers${findString ? '/'+findString : ''}?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: SET_PERMANENT_STAFF, payload: data });
    }
  }
};

export const fetchPermanentStaffCount = (findString, findDivision, status) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const params = {
      count: true,
      status: status
    }
    findDivision!=='all' && (params.division = findDivision)
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/teachers${findString ? '/'+findString : ''}?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      // счётчик «Найдено записей» берётся из того же метода в режиме возврата количества
      const count = Number(data?.[0]?.count) || 0;
      const payload = { pagesCount: Math.ceil(count / itemsOnPage), totalCount: count };
      await dispatch({ type: SET_PERMANENT_STAFF_PAGES_COUNT, payload });
    }
  }
};

export const fetchDivisions = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/divisions`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const payload = await response.json();
      await dispatch({ type: SET_DIVISIONS, payload });
    }
  }
};

export const fetchGroupsByFacultyAndYear = (facultyId, course, chosenDate) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group/${facultyId}/${course}/${chosenDate}`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const payload = await response.json();
      await dispatch({ type: SET_GROUPS_BY_COURSE, payload });
    }
  }
};

export const rashodRemove = () => ({ type: RASHOD_REMOVE })
